<div class="container-fluid">
    <div class="row">
        <div class="col-md-8">
            <small class="link" (click)="backToDashboard()">
                Home > Employee Management
            </small>
            <div class="mat-title titleColor font-weight-bold">Manage Employees</div>
            <div class="mat-subheading-1 titleColor">Manage existing employees or create new</div>

        </div>

        <div class="col-md-4">
            <div class="_action">
                <!-- <button mat-flat-button color="default" class="text-uppercase _btn"><mat-icon class="_add">add</mat-icon>Add Beneficiary</button> -->
                <button mat-flat-button color="default" (click)="openFormModalCreate()"
                    class="text-uppercase _btn"><mat-icon class="_add">add</mat-icon>Create New Employee</button>
            </div>
        </div>
    </div>
    <!-- <mat-divider></mat-divider> -->


    <div class="mat-elevation-z8 mt-2">

        <div class="bgWhite noMargin w100">
            <div class="row">
                <div class="col-md-6 mt-3 mb-3">
                    <div class="col-md-4 p-0">
                        <p class="label-cls ddLabel"><b>View By</b></p>
                        <p-dropdown [options]="viewEmployeeBy" [(ngModel)]="employeeViewBy"
                            placeholder="Select a document type"></p-dropdown>
                    </div>
                </div>
                <div class="col-md-3 pull-right">
                    <div class="filterContainer">

                        <ul>
                            <li (click)="listView()"><i class="fa fa-bars" aria-hidden="true"></i></li>
                            <li class="activeBar"><i class="fa fa-th" aria-hidden="true"></i></li>
                            
                            <!-- Hiding for now, will enable once we get exact functionality -->
                            <!-- <li>
                                <div (click)="filterOpen()"><i class="fa fa-filter filter" aria-hidden="true"></i></div>
                            </li> -->
                        </ul>

                        <div class="filterComponent" *ngIf="isFilter" (click)="stopPropagation($event)">
                            <h2>Filter</h2>
                            <span class="close-icon" (click)="closeFilter()"><i class="fa fa-times"
                                    aria-hidden="true"></i></span>
                            <div class="clearfix"></div>
                            <h3>View By</h3>

                            <div class="filterForm">
                                <label for="name">Name</label>
                                <input type="text" class="form-control" [(ngModel)]="filter.name" id="name"
                                    aria-describedby="name" placeholder="Enter Name">


                                <h3 class="mt-20">Employee having</h3>

                                <div class="form-check pull-left">
                                    <input class="form-check-input filterRadio" type="radio" value="LCA"
                                        [(ngModel)]="filter.type" name="filterRadio" id="filterRadio1">
                                    <label class="form-check-label filterLabel" for="filterRadio1">LCA</label>
                                </div>

                                <div class="form-check  pull-left">
                                    <input class="form-check-input filterRadio" type="radio" value="I9Forms"
                                        [(ngModel)]="filter.type" name="filterRadio" id="filterRadio2">
                                    <label class="form-check-label filterLabel" for="filterRadio2">I-9 Form</label>
                                </div>

                                <div class="form-check  pull-left">
                                    <input class="form-check-input filterRadio" type="radio" value="EVerified"
                                        [(ngModel)]="filter.type" name="filterRadio" id="filterRadio3">
                                    <label class="form-check-label filterLabel" for="filterRadio3">E-Verify</label>
                                </div>
                            </div>

                            <button class="btn btn-primary customButton" (click)="filterAction()"
                                [disabled]="filter.type == '' || filter.name == ''">Submit</button>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 mt-3 mb-3">
                    <div class="input-group">
                        <input class="form-control py-2 rounded-pill pr-5" (keyup.enter)="resetSearch()"
                            [(ngModel)]="searchText" type="search" #searchBeneficiaryListTable
                            placeholder="Search Employee">
                        <span class="input-group-append">
                            <button class="btn rounded-pill border-0 ml-n4r" type="button">
                                <i class="fa fa-search"></i>
                            </button>
                        </span>
                    </div>
                </div>

                <div class="clearfix"></div>

                <div class="col-md-12 mat-elevation-z8 mt-2" *ngIf="displayedData.length > 0">
                    <div *ngIf="employeeViewBy == 'activeEmployees'">
                        <mat-tab-group (selectedTabChange)="onTabChange($event)">
                            <mat-tab label="All ({{this.allEmployeesData.notIntiatedList.length + this.inProgressList.length + this.allEmployeesData.completedList.length}})">
                                <div class="parent">
                                    <div class="child" *ngFor="let _data of displayedData" (click)="editBene(_data)">
                                        <div class="userImage"><img
                                                src="https://pl.imagility.co/compliance/assets/profile_grid.png"></div>
                                        <div class="heading" *ngIf="_data.beneficiaryName != '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName != '  '">
                                            {{_data.beneficiaryName}}</div>
                                        <div class="heading" *ngIf="_data.beneficiaryName == '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName == '  '">
                                            Unknown</div>
                                        <mat-divider></mat-divider>
            
                                        <div class="parent">
                                            <div class="subchild" (click)="editBene(_data)">LCA</div>
                                            <div class="subchild" (click)="editBene(_data)">I-9 Form</div>
                                            <div class="subchild" (click)="editBene(_data)">E-Verify</div>
                                        </div>
                                    </div>
            
                                    <div class="text-right" style="width: 100%;">
                                        <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                            [length]="displayedData.length" (page)="paginationEvent($event)"></mat-paginator>
                                    </div>
            
                                </div>
                            </mat-tab>
                            <mat-tab label="Not Initiated ({{this.allEmployeesData.notIntiatedList.length}})">
                                <div class="parent">
                                    <div class="child" *ngFor="let _data of displayedData" (click)="editBene(_data)">
                                        <div class="userImage"><img
                                                src="https://pl.imagility.co/compliance/assets/profile_grid.png"></div>
                                        <div class="heading" *ngIf="_data.beneficiaryName != '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName != '  '">
                                            {{_data.beneficiaryName}}</div>
                                        <div class="heading" *ngIf="_data.beneficiaryName == '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName == '  '">
                                            Unknown</div>
                                        <mat-divider></mat-divider>
            
                                        <div class="parent">
                                            <div class="subchild" (click)="editBene(_data)">LCA</div>
                                            <div class="subchild" (click)="editBene(_data)">I-9 Form</div>
                                            <div class="subchild" (click)="editBene(_data)">E-Verify</div>
                                        </div>
                                    </div>
            
                                    <div class="text-right" style="width: 100%;">
                                        <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                            [length]="displayedData.length" (page)="paginationEvent($event)"></mat-paginator>
                                    </div>
            
                                </div>
                            </mat-tab>
                            <mat-tab label="In Progress ({{this.inProgressList.length}})">
                                <mat-tab-group (selectedTabChange)="onInProgressTabChange($event)">
                                    <mat-tab label="All ({{this.inProgressList.length}})">
                                        <div *ngIf="this.displayedData && this.displayedData.length > 0">
                                            <div class="parent">
                                                <div class="child" *ngFor="let _data of displayedData" (click)="editBene(_data)">
                                                    <div class="userImage"><img
                                                            src="https://pl.imagility.co/compliance/assets/profile_grid.png"></div>
                                                    <div class="heading" *ngIf="_data.beneficiaryName != '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName != '  '">
                                                        {{_data.beneficiaryName}}</div>
                                                    <div class="heading" *ngIf="_data.beneficiaryName == '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName == '  '">
                                                        Unknown</div>
                                                    <mat-divider></mat-divider>
                        
                                                    <div class="parent">
                                                        <div class="subchild" (click)="editBene(_data)">LCA</div>
                                                        <div class="subchild" (click)="editBene(_data)">I-9 Form</div>
                                                        <div class="subchild" (click)="editBene(_data)">E-Verify</div>
                                                    </div>
                                                </div>
                        
                                                <div class="text-right" style="width: 100%;">
                                                    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                                        [length]="displayedData.length" (page)="paginationEvent($event)"></mat-paginator>
                                                </div>
                                            </div>
                                        </div>
        
                                        <mat-divider *ngIf="this.displayedData && this.displayedData.length <= 0"></mat-divider>
        
                                        <div class="text-center mt-2 p-2"
                                            *ngIf="this.displayedData && this.displayedData.length <= 0">
                                            No Records
                                        </div>
                                    </mat-tab>
        
                                    <mat-tab label="Initiated ({{this.initiatedData.length}})">
                                        <div *ngIf="this.displayedData && this.displayedData.length > 0">
                                            <div class="parent">
                                                <div class="child" *ngFor="let _data of displayedData" (click)="editBene(_data)">
                                                    <div class="userImage"><img
                                                            src="https://pl.imagility.co/compliance/assets/profile_grid.png"></div>
                                                    <div class="heading" *ngIf="_data.beneficiaryName != '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName != '  '">
                                                        {{_data.beneficiaryName}}</div>
                                                    <div class="heading" *ngIf="_data.beneficiaryName == '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName == '  '">
                                                        Unknown</div>
                                                    <mat-divider></mat-divider>
                        
                                                    <div class="parent">
                                                        <div class="subchild" (click)="editBene(_data)">LCA</div>
                                                        <div class="subchild" (click)="editBene(_data)">I-9 Form</div>
                                                        <div class="subchild" (click)="editBene(_data)">E-Verify</div>
                                                    </div>
                                                </div>
                        
                                                <div class="text-right" style="width: 100%;">
                                                    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                                        [length]="displayedData.length" (page)="paginationEvent($event)"></mat-paginator>
                                                </div>
                                            </div>
        
                                        </div>
        
                                        <mat-divider *ngIf="this.displayedData && this.displayedData.length <= 0"></mat-divider>
        
                                        <div class="text-center mt-2 p-2"
                                            *ngIf="this.displayedData && this.displayedData.length <= 0">
                                            No Records
                                        </div>
                                    </mat-tab>
        
                                    <mat-tab label="Verify Yourself ({{this.verifyYourselfData.length}})">
                                        <div *ngIf="this.displayedData && this.displayedData.length > 0">
                                            <div class="parent">
                                                <div class="child" *ngFor="let _data of displayedData" (click)="editBene(_data)">
                                                    <div class="userImage"><img
                                                            src="https://pl.imagility.co/compliance/assets/profile_grid.png"></div>
                                                    <div class="heading" *ngIf="_data.beneficiaryName != '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName != '  '">
                                                        {{_data.beneficiaryName}}</div>
                                                    <div class="heading" *ngIf="_data.beneficiaryName == '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName == '  '">
                                                        Unknown</div>
                                                    <mat-divider></mat-divider>
                        
                                                    <div class="parent">
                                                        <div class="subchild" (click)="editBene(_data)">LCA</div>
                                                        <div class="subchild" (click)="editBene(_data)">I-9 Form</div>
                                                        <div class="subchild" (click)="editBene(_data)">E-Verify</div>
                                                    </div>
                                                </div>
                        
                                                <div class="text-right" style="width: 100%;">
                                                    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                                        [length]="displayedData.length" (page)="paginationEvent($event)"></mat-paginator>
                                                </div>
                                            </div>
                                        </div>
        
                                        <mat-divider *ngIf="this.displayedData && this.displayedData.length <= 0"></mat-divider>
        
                                        <div class="text-center mt-2 p-2"
                                            *ngIf="this.displayedData && this.displayedData.length <= 0">
                                            No Records
                                        </div>
                                    </mat-tab>
        
        
                                    <mat-tab label="Video Verification ({{this.videoVerificationData.length}})">
                                        <div *ngIf="this.displayedData && this.displayedData.length > 0">
                                            <div class="parent">
                                                <div class="child" *ngFor="let _data of displayedData" (click)="editBene(_data)">
                                                    <div class="userImage"><img
                                                            src="https://pl.imagility.co/compliance/assets/profile_grid.png"></div>
                                                    <div class="heading" *ngIf="_data.beneficiaryName != '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName != '  '">
                                                        {{_data.beneficiaryName}}</div>
                                                    <div class="heading" *ngIf="_data.beneficiaryName == '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName == '  '">
                                                        Unknown</div>
                                                    <mat-divider></mat-divider>
                        
                                                    <div class="parent">
                                                        <div class="subchild" (click)="editBene(_data)">LCA</div>
                                                        <div class="subchild" (click)="editBene(_data)">I-9 Form</div>
                                                        <div class="subchild" (click)="editBene(_data)">E-Verify</div>
                                                    </div>
                                                </div>
                        
                                                <div class="text-right" style="width: 100%;">
                                                    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                                        [length]="displayedData.length" (page)="paginationEvent($event)"></mat-paginator>
                                                </div>
                                            </div>
                                        </div>
        
                                        <mat-divider *ngIf="this.displayedData && this.displayedData.length <= 0"></mat-divider>
        
                                        <div class="text-center mt-2 p-2"
                                            *ngIf="this.displayedData && this.displayedData.length <= 0">
                                            No Records
                                        </div>
                                    </mat-tab>
        
                                    <mat-tab label="Evaluator ({{this.verificationByEvaluatorData.length}})">
                                        <div *ngIf="this.displayedData && this.displayedData.length > 0">
                                            <div class="parent">
                                                <div class="child" *ngFor="let _data of displayedData" (click)="editBene(_data)">
                                                    <div class="userImage"><img
                                                            src="https://pl.imagility.co/compliance/assets/profile_grid.png"></div>
                                                    <div class="heading" *ngIf="_data.beneficiaryName != '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName != '  '">
                                                        {{_data.beneficiaryName}}</div>
                                                    <div class="heading" *ngIf="_data.beneficiaryName == '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName == '  '">
                                                        Unknown</div>
                                                    <mat-divider></mat-divider>
                        
                                                    <div class="parent">
                                                        <div class="subchild" (click)="editBene(_data)">LCA</div>
                                                        <div class="subchild" (click)="editBene(_data)">I-9 Form</div>
                                                        <div class="subchild" (click)="editBene(_data)">E-Verify</div>
                                                    </div>
                                                </div>
                        
                                                <div class="text-right" style="width: 100%;">
                                                    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                                        [length]="displayedData.length" (page)="paginationEvent($event)"></mat-paginator>
                                                </div>
                                            </div>
                                        </div>
        
                                        <mat-divider *ngIf="this.displayedData && this.displayedData.length <= 0"></mat-divider>
        
                                        <div class="text-center mt-2 p-2"
                                            *ngIf="this.displayedData && this.displayedData.length <= 0">
                                            No Records
                                        </div>
                                    </mat-tab>
        
                                    <mat-tab label="Authorized Person ({{this.verificationByAuthRepresenativeData.length}})">
        
                                        <div *ngIf="this.displayedData && this.displayedData.length > 0">
                                            <div class="parent">
                                                <div class="child" *ngFor="let _data of displayedData" (click)="editBene(_data)">
                                                    <div class="userImage"><img
                                                            src="https://pl.imagility.co/compliance/assets/profile_grid.png"></div>
                                                    <div class="heading" *ngIf="_data.beneficiaryName != '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName != '  '">
                                                        {{_data.beneficiaryName}}</div>
                                                    <div class="heading" *ngIf="_data.beneficiaryName == '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName == '  '">
                                                        Unknown</div>
                                                    <mat-divider></mat-divider>
                        
                                                    <div class="parent">
                                                        <div class="subchild" (click)="editBene(_data)">LCA</div>
                                                        <div class="subchild" (click)="editBene(_data)">I-9 Form</div>
                                                        <div class="subchild" (click)="editBene(_data)">E-Verify</div>
                                                    </div>
                                                </div>
                        
                                                <div class="text-right" style="width: 100%;">
                                                    <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                                        [length]="displayedData.length" (page)="paginationEvent($event)"></mat-paginator>
                                                </div>
                                            </div>
                                        </div>
        
                                        <mat-divider *ngIf="this.displayedData && this.displayedData.length <= 0"></mat-divider>
        
                                        <div class="text-center mt-2 p-2"
                                            *ngIf="this.displayedData && this.displayedData.length <= 0">
                                            No Records
                                        </div>
                                    </mat-tab>
                                </mat-tab-group>
                            </mat-tab>
                            <mat-tab label="Completed ({{this.allEmployeesData.completedList.length}})">
                                <div class="parent">
                                    <div class="child" *ngFor="let _data of displayedData" (click)="editBene(_data)">
                                        <div class="userImage"><img
                                                src="https://pl.imagility.co/compliance/assets/profile_grid.png"></div>
                                        <div class="heading" *ngIf="_data.beneficiaryName != '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName != '  '">
                                            {{_data.beneficiaryName}}</div>
                                        <div class="heading" *ngIf="_data.beneficiaryName == '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName == '  '">
                                            Unknown</div>
                                        <mat-divider></mat-divider>
            
                                        <div class="parent">
                                            <div class="subchild" (click)="editBene(_data)">LCA</div>
                                            <div class="subchild" (click)="editBene(_data)">I-9 Form</div>
                                            <div class="subchild" (click)="editBene(_data)">E-Verify</div>
                                        </div>
                                    </div>
                                    <div class="text-right" style="width: 100%;">
                                        <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                            [length]="displayedData.length" (page)="paginationEvent($event)"></mat-paginator>
                                    </div>
                                </div>
                            </mat-tab>
                        </mat-tab-group>
                    </div>
                    <div *ngIf="employeeViewBy != 'activeEmployees'">
                        <div class="parent">
                            <div class="child" *ngFor="let _data of displayedData" (click)="editBene(_data)">
                                <div class="userImage"><img
                                        src="https://pl.imagility.co/compliance/assets/profile_grid.png"></div>
                                <div class="heading" *ngIf="_data.beneficiaryName != '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName != '  '">
                                    {{_data.beneficiaryName}}</div>
                                <div class="heading" *ngIf="_data.beneficiaryName == '  ' || _data.beneficiaryName == ' ' || _data.beneficiaryName == '  '">
                                    Unknown</div>
                                <mat-divider></mat-divider>
    
                                <div class="parent">
                                    <div class="subchild" (click)="editBene(_data)">LCA</div>
                                    <div class="subchild" (click)="editBene(_data)">I-9 Form</div>
                                    <div class="subchild" (click)="editBene(_data)">E-Verify</div>
                                </div>
                            </div>
    
                            <div class="text-right" style="width: 100%;">
                                <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"
                                    [length]="displayedData.length" (page)="paginationEvent($event)"></mat-paginator>
                            </div>
    
                        </div>
                    </div>
                </div>

                <ng-template *ngIf="noRecordFound">
                    <div *ngIf="displayedData.length == 0" style="border: 1px solid #cecece; text-align: center; width: 100%; padding: 40px;
                font-size: 26px; vertical-align: middle;;">
                        No Record Found
                    </div>
                </ng-template>

            </div>
        </div>
    </div>